export default {
  CONTACTUS: {
    TITLE: 'Contact Us',
    SUBTITLE: 'Jika Anda memiliki pertanyaan, anggota staf kami akan selalu dengan senang hati membantu. Jangan ragu untuk menghubungi kami melalui telepon dan kami pasti akan membalas Anda sesegera mungkin.',
    CHAT: 'Chat via Whatsapp'
  }
}
